import {ENTITIES_TARIFFS_BASE_URL} from 'app/app.constants';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {SpecialTypeService} from 'app/blocks/service/api/special-type.service';
import {Resource} from 'app/constants/resource';

import {ISpecialType, SpecialType} from 'app/blocks/model/special-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class SpecialTypeResource extends AbstractEntityResource<ISpecialType> {
    constructor(specialTypeService: SpecialTypeService, router: Router) {
        super(
            Resource.SPECIAL_TYPES,
            specialTypeService,
            new EntityNavigator(ENTITIES_TARIFFS_BASE_URL, Resource.SPECIAL_TYPES, router),
            new EntityUrlProvider(ENTITIES_TARIFFS_BASE_URL, Resource.SPECIAL_TYPES),
            (entity?) => new SpecialType(entity),
            (entity) => entity.id,
            faStar
        );
    }

    getEntityDiscriminator(entity: SpecialType): any {
        return entity.id?.toString() + (entity.description ? ' - ' + entity.description : '');
    }
}
